<!-- 總筆數mobile -->
<div class="total-records-wrap">
  <div class="p-d-flex p-ai-center p-jc-center p-m-2 p-d-md-none total-recors-content">
    {{ "Search.Common.TotalRecords" | translate }}
    <font class="count">{{ totalRecords | number:'1.0-0' }}</font>
    {{ "Search.Common.Records" | translate }}
  </div>
  <div class="mobile-switch-btngroup" *ngIf="showMobileSwitch">
    <p-button icon="pi pi-mobilelist" (click)="showMobileLayout()" [ngClass]="{'mobile-switch-btnactive': mobileBtnActive}"></p-button>
    <p-button icon="pi pi-pclist" (click)="showDesktopLayout()" [ngClass]="{'mobile-switch-btnactive': !mobileBtnActive}"></p-button>
  </div>
</div>
